<template>
  <div>
    <div style="margin-bottom: 30px;">
      当前机器人：{{$route.params.nickname}}({{$route.params.username}})</div>
    <a-collapse v-model="activeKey" style="width: 800px">
      <a-collapse-panel header="选择机器人好友：" key="1">
        <a-transfer
          :dataSource="botFriendsList"
          :titles="['未选', '已选']"
          :targetKeys="targetKeys"
          @change="handleChange"
          :render="item=>item.title"
        />
      </a-collapse-panel>
      <a-collapse-panel header="选择素材：" key="2">
        <a-table
          :columns="columns"
          :dataSource="materialList"
          :rowSelection="rowSelection"
          :pagination="pagination"
        ></a-table>
      </a-collapse-panel>
    </a-collapse>
    <div style="margin: 30px 0 180px; display: flex; line-height: 32px;">
      <div style="width: 180px;">消息间的时间间隔（秒）：</div>
      <a-input style="width: 100px;" v-model="intervalMin"></a-input>
      <div style="margin: 0 10px 0 10px;">--</div>
      <a-input style="width: 100px" v-model="intervalMax"></a-input>
      <span style="font-size: 12px; color: #999999">&emsp;&emsp;(最小值--最大值)</span>
    </div>
    <div style="display: none">
      <div style="width: 180px">人与人间的时间间隔：</div>
      <a-input style="width: 200px" v-model="timeSpanOfPeople" :disabled="true"></a-input>
    </div>
    <div style="margin: auto; display: flex; width: 150px; justify-content: space-between">
      <a-button @click="Sending">发送</a-button>
      <a-button onclick="window.history.go(-1)">返回</a-button>
    </div>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'GroupSending',
  data () {
    return {
      activeKey: undefined,
      targetKeys: undefined,
      getBotFriendsUrl: global.DOMAIN + global.API_VERSION + 'ubot/get_friends',
      getMaterialListUrl: global.DOMAIN + global.API_VERSION + 'ubatchsend/get_material_list',
      sendingUrl: global.DOMAIN + global.API_VERSION + 'ubatchsend/create',
      intervalMin: undefined,
      intervalMax: undefined,
      timeSpanOfPeople: undefined,
      selectedMaterial: undefined,
      botFriendsList: [],
      materialList: [],
      columns: [
        {
          title: '素材创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '素材概览',
          dataIndex: 'material'
        },
        {
          title: '录制人',
          dataIndex: 'nickname'
        }
      ],
      rowSelection: {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedMaterial = selectedRows
        }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        showTotal: total => `共 ${total} 个素材`
      }
    }
  },
  methods: {
    getFriendsList () {
      axios.post(this.getBotFriendsUrl, {
        bot_username: this.$route.params.username,
        token: sessionStorage.token
      }).then((res) => {
        this.botFriendsList = res.data.content.friend_nickname_list
        this.botFriendsList.forEach(item => {
          item.key = item.username
          item.title = item.nickname
        })
      })
    },
    getMaterialList () {
      axios.post(this.getMaterialListUrl, {
        token: sessionStorage.token,
        page: this.pagination.current,
        pagesize: this.pagination.pageSize
      }).then((res) => {
        this.materialList = res.data.content.material_list
        this.pagination.total = res.data.content.total_count
        this.materialList.forEach(item => {
          item.material =
            item.text_count + '文字; ' +
            item.pic_count + '图片; ' +
            item.audio_count + '录音;' +
            item.vedio_count + '视频; ' +
            item.link_count + '链接; ' +
            item.minprogram_count + '小程序;'
          item.create_time = this.timeTransform(item.create_time)
        })
      })
    },
    Sending () {
      if (this.$route.params.username &&
        this.targetKeys &&
        this.selectedMaterial &&
        this.intervalMin &&
        this.intervalMax) {
        axios.post(this.sendingUrl, {
          token: sessionStorage.token,
          bot_username: this.$route.params.username,
          friend_list: this.targetKeys,
          friend_batchsend_material_id: this.selectedMaterial[0].friend_batchsend_material_id,
          interval_min: parseInt(this.intervalMin),
          interval_max: parseInt(this.intervalMax)
        }).then((res) => {
          if (res.data.err_code === 0) {
            this.$message.success('发送成功')
            this.intervalMin = undefined
            this.intervalMax = undefined
            this.targetKeys = undefined
          } else {
            this.$message.error('发送失败')
          }
        })
      } else {
        this.$message.error('发送失败')
      }
    },
    handleChange (nextTargetKeys) {
      this.targetKeys = nextTargetKeys
    },
    handleTableChange (pagination) {
      const pager = {...this.pagination}
      pager.current = pagination.current
      this.pagination = pager
      this.getMaterialList()
    },
    timeTransform (time, detail = true) {
      const d = new Date(time * 1000)
      return d.getFullYear() + '-' +
        (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' +
        (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' +
        (detail ? ((d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' +
          (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' +
          (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())) : '')
    }
  },
  mounted () {
    this.getFriendsList()
    this.getMaterialList()
  }
}
</script>

<style scoped>
.ant-collapse {
  border: 0!important;
  background-color: white!important;
}
.ant-collapse > .ant-collapse-item {
  border-bottom: 0!important;
}
</style>
